export const BAG_CLASS_TO_TOKEN = {
    "path-base": "bagBaseColor",
    "path-trace": "bagTraceBaseColor",
    "path-side-bag": "bagSideColor",
    "path-lateral-stroke": "bagLateralStroke",
    "path-front-bag": "bagFrontBag",
    "path-signal": "bagSignal",
    "path-shadow": "bagShadow",
    "path-counter-badge": "bagCounterBadge",
    "path-text-counter-badge": "bagTextCounterBadge",
    "path-strap": "bagStrap",
};

export const DECLINED_CLASS_TO_TOKEN = {
    "path-declined-ink": "declinedInk",
    "path-declined-mark": "declinedMark",
    "path-declined-button": "declinedButton",
};
